// NOTE: DO NOT UPDATE THIS RESERVED TRANSLATION KEYS AND THEIR VALUES
const reservedTranslationsWithUniqueKeyNames = {
  leadingSpaceNotAllowed: 'Leading space not allowed.',
  trailingSpaceNotAllowed: 'Trailing space not allowed.',
  mustbeAtleastCharacters: '{{label}} must be atleast {{minNumber}} characters',
  cannotExceedCharacters: '{{label}} cannot exceed {{maxNumber}} characters',
  numberMustbeAtleast: '{{label}} must be atleast value {{minNumber}}',
  numberCannotExceed: '{{label}} cannot exceed {{maxNumber}}',
  isRequired: '{{label}} is required',
  emptySpaceNotContain: 'This field cannot contain space',
  404: '404',
  register: 'Register',
  login: 'Login',
  comingSoon: 'Coming Soon',
  submit: 'Submit',
  email: 'Email',
  termsConditions: 'Terms & Conditions',
  password: 'Password',
  eighteenPlus: 'I’m over 18 years of age and I agree to the Terms of Service',
  signUp: 'SignUp',
  createNewAccount: 'Create New Account',
  fullName: 'Full Name',
  referralCode: 'Referral Code',
  confirmPassword: 'Confirm Password',
  facebook: ' Facebook',
  google: 'Google',
  haveAnAccount: 'Have an account? ',
  pageNotFound: 'We can’t find the page you are looking for!',
  error: 'Error',
  somethingWentWrong: 'Something went wrong!',
  personalDetails: 'Personal Details',
  firstName: 'First Name',
  lastName: 'Last Name',
  dateOfBirth: 'Date of birth',
  phoneNumber: 'Phone Number',
  change: 'Change',
  saveChanges: 'Save Change',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  myProfile: 'My Profile',
  transactions: 'Transactions',
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  referral: 'Referral',
  changePassword: 'Change Password',
  logout: 'Logout',
  currency: 'Currency.',
  view: 'View',
  ok: 'Ok',
  cancel: 'Cancel',
  userName: 'Username',
  passwordRegexMatch: 'Password must contain one uppercase, one number and one special case character',
  invalidEmailFormat: 'Invalid email format',
  noRecordsFound: 'No Records Found',
  backToLobby: 'Back to lobby'
}

// NOTE: PLEASE ADD YOUR API SUCCESS MESSAGE TRANSLATIONS HERE ONLY
const apiSuccessMessagesTranslations = {
  loginSuccessfully: 'Login successfully.',
  logoutSuccessfully: 'Logout successfully.',
  passwordUpdateSuccessfully: 'Password updated successfully.',
  updatePlayerStatusSuccessfully: 'Player status updated successfully.',
  resetPasswordSuccessfully: 'Password reset successfully.',
  signupSuccessfully: 'Signup successfully.',
  betPlacedSuccessfully: 'Bet Placed  successfully.',
  betCancelledSuccessfully: 'Bet cancelled  successfully.'
}

// NOTE: PLEASE ADD YOUR API ERROR MESSAGE TRANSLATIONS HERE ONLY
const apiErrorMessagesTranslations = {
  UnAuthorized: 'Your session has timed out',
  LoginFailedError: 'Login Failed',
  InvalidCredentialsError: 'Invalid Credentials',
  InvalidTokenError: ' Token is not valid',
  InvalidSessionError: ' Session expired',
  CreateUserError: 'User cannot be created',
  DataMismatchError: 'Data does not match',
  UserNotFoundError: 'User not found',
  DuplicateEmailError: 'Email already exists',
  RequestInputValidationError: 'Please check the request data',
  ResponseInputValidationError: 'Response validation failed please refer to the JSON schema of the response',
  SocketRequestInputValidationError: 'Please check the request data for socket communication',
  SocketResponseValidationError: 'Response validation of socket communication failed, please refer to the JSON schema of the response',
  InternalServerError: 'Internal Server Error',
  InvalidSocketArgumentError: 'Please provide proper arguments: eventName, [payloadObject], and [callback]',
  InvalidCredentials: 'Credentials do not match',
  InvalidToken: 'Either access token was not passed or it has expired',
  InvalidSession: 'User session is not valid, please re-login',
  InvalidAccess: 'Permission denied',
  NonOperationalError: 'An error occurred on the server',
  UserNotExists: 'User does not exist',
  InvalidAction: 'Invalid action',
  SessionAlreadyStarted: 'Session already started',
  SessionNotStarted: 'Session not started',
  EmailNotVerified: 'Email not verified',
  InvalidGameTypeError: 'No settings found for the provided game type',
  InvalidGameRoundError: 'No game found for the provided game details',
  NoRoundRunningError: 'No round is running at the moment',
  NoPlacedBetFoundError: 'No placed bet found',
  NoWalletFoundError: 'Wallet not found with the specified data',
  NotEnoughBalanceError: 'Balance is not sufficient to perform the process',
  AutoRateIsInvalidError: 'Auto Rate is not within the valid limit',
  BetAmountIsNotInLimitError: 'Bet Amount is not within the valid limits',
  EmailNotFound: 'Email not found',
  UserNotAbove18YearsError: 'User is not above 18 years old',
  InvalidBlockchainAddress: 'Invalid Blockchain Address',
  AddressMismatch: 'Given Address and Recovered Address Mismatch',
  NonceLifetimeExpired: 'Nonce Lifetime Expired',
  SomethingWentWrong: 'Something Went Wrong',
  AccountNotActive: 'Account is not active',
  LoginTokenRequire: 'OTP (One-Time Password) is required',
  UserAlreadyExists: 'User already exists',
  InvalidVerificationToken: 'Invalid verification token',
  UserNotActive: 'User is blocked, please contact admin',
  FileUploadFailed: 'Image upload failed',
  EmailAlreadyVerified: 'Email is already verified',
  InvalidReferralCode: 'Invalid Referral Code',
  InvalidAffiliateCode: 'Invalid Affiliate Code',
  RecordNotFound: 'Record Not Found',
  WithdrawalRequestAlreadyPending: 'Withdrawal request is already pending',
  WalletDoesNotBelongToUser: 'Wallet does not belong to this user',
  BetAlreadyInProgress: 'Bet is already in progress',
  ServerSeedNotFoundErrorType: 'Server seed not found, please log in again',
  BlackJackPreviousRoundNotCompletedErrorType: 'Black Jack Game previous round not completed',
  BlackJackGameDoubleBetErrorType: 'Black Jack Game unable to double the bet',
  BlackJackGameSplitBetErrorType: 'Black Jack Game unable to split the bet',
  BlackJackGameSplitHitErrorType: 'Black Jack Game unable to draw a card',
  FavoriteGameExistsErrorType: 'Favorite Game already exists',
  FavoriteGameNotFoundErrorType: 'Favorite Game not found',
  TransactionAlreadyPendingErrorType: 'Transaction is already pending',
  UserHasNoActiveBonusErrorType: 'User has no active bonus',
  BonusExpiredErrorType: 'Bonus has expired',
  UserHasAlreadyActivatedBonusWageringErrorType: 'User has already activated bonus wagering',
  InvalidRoundHashErrorType: 'Wrong Round Hash',
  InvalidSignatureErrorType: 'Wrong Signature',
  UserHasNoBonusAmountToClaimErrorType: 'User has no bonus amount to claim',
  BonusNotExistsErrorType: 'Bonus not found',
  BlockedTransactionErrorType: 'Transaction block error'
}

// NOTE: PLEASE ADD YOUR OTHER KEY TRANSLATIONS HERE ONLY
const otherTranslationKeys = {
  betAmount: 'Bet Amount',
  betHistory: 'Bet History',
  provablyFair: 'Provably Fair',
  minimumBet: 'Minimum bet',
  maximumBet: 'Maximum bet',
  selectYourBetAmount: 'Select your bet amount',
  buyInAmount: 'BuyIn Amount',
  selectYourBuyInAmountFromGivenRange: 'Select your BuyIn Amount from given range',
  profitOnWin: 'Profit on Win',
  noOfBets: 'Number of bets',
  auto: 'Auto',
  half: '½',
  double: '2X',
  start: 'Start',
  cancel: 'Cancel',
  prediction: 'Prediction',
  luckyNumber: 'Lucky Number',
  multiplier: 'Multiplier',
  chanceToWin: 'Chance to win',
  betBtn: 'Place Bet',
  bets: 'Bets',
  depositBtn: 'Deposit',
  rollOver: 'Roll Over',
  rollUnder: 'Roll Under',
  invalidBetAmount: 'Invalid bet amount',
  maxBetAmountLimit: 'Max bet amount {{value}} limit exceeded',
  minBetAmountLimit: 'Min bet amount is {{value}}.',
  noBalance: 'Bet amount is greater than wallet balance',
  noAutoCashout: 'Auto rate is required.',
  autoRateLimitWarning: 'Auto rate should be greater than {{value}}',
  notEnoughBalance: 'Not enough balance',
  betCancelled: 'Bet cancelled',
  sessionOut: 'Session out',
  sessionOutMessage: 'Please try with new session'
}

/**
 * NOTE:
 * =================================================================================================
 * Please go through this spreading objects first before adding new translation key. So that the
 * duplicate translations will not be created and help us to maintain the consitency of code.
 * If you didn't find any of translation as per your requirement in reserve or api success & error
 * msg translation object, Please add new translation with unique key name in otherTranslationKeys
 * Object. Unique key names help us to avoid overriding of translations.
 * =================================================================================================
 */
export default {
  ...reservedTranslationsWithUniqueKeyNames,
  ...apiSuccessMessagesTranslations,
  ...apiErrorMessagesTranslations,
  ...otherTranslationKeys
}
